/**
 * @ngdoc service
 * @name mwAnnouncementService
 * @module mw.components.announcement
 *
 * @description
 * A service used to open announcements,
 * the service expects you to pass it a string or html in which is will procces
 * as well as a onClose event (optional) if there is any additional
 * functionality you need to take care of when closing the announcement
 */

/**
 * @ngdoc method
 * @name mwAnnouncementService#open
 * @param {string|object} [config] - String of content (can be HTML) that will be displayed in the announcement OR announcement panel config override
 *
 *
 * @returns promise that resolves with a reference to the $mdPanelRef
 */

export class AnnouncementService {
    constructor(private $window, private $mdPanel) {
        'ngInject';
    }

    open(announcementConfig: string | object = {}) {
        let appContainerEl = this.$window.document.querySelector('.mw-app-container')
        let announcementsContainerEl = this.$window.document.querySelector('.mw-announcements')
        if (!announcementsContainerEl) {
            announcementsContainerEl = angular.element('<div class="mw-announcements"></div>')[0];
            // Insert announcements container before app container
            appContainerEl.parentNode.insertBefore(announcementsContainerEl, appContainerEl);
        }

        let panelConfig = Object.assign(
            {
                attachTo: announcementsContainerEl,
                controllerAs: '$ctrl',
                controller: class AnnouncemntPanel {
                    constructor (private mdPanelRef) {
                        'ngInject';
                    }
                    close() {
                        this.mdPanelRef.close();
                    }
                },
                template: `
                    <mw-announcement on-close="$ctrl.close($event)">{{$ctrl.text}}</mw-announcement>
                `,
                locals: {
                    text: typeof announcementConfig === 'string' ? announcementConfig : null
                },
                panelClass: 'mw-announcement__panel',
                focusOnOpen: false,
                zIndex: 100,
                propagateContainerEvents: true,
                groupName: 'mwAnnouncements'
            },
            announcementConfig
        );

        return this.$mdPanel.open(panelConfig);
    }

}



// WEBPACK FOOTER //
// ./src/lib/components/announcement/announcement.service.ts